import React from "react";
import "../../Stylesheets/Footer/Footer.scss";
import location from "../../assests/Images/Footer/location2.png";
import facebook from "../../assests/Images/Footer/facebook2.png";
import instagram from "../../assests/Images/Footer/instagram2.png";
import linkedin from "../../assests/Images/Footer/linkedid2.png";
import whatsapp from "../../assests/Images/Footer/whatsapp2.png";
import telephone from "../../assests/Images/icons/telephone.png";
import phone from "../../assests/Images/icons/phone.png";
import twitter from "../../assests/Images/Footer/twitter2.png";
import $ from "jquery"
const Footer = () => {
  // $(function(){
  //   $("#tel").on("click touchstart", function(event){
  //     event.preventDefault(); // Prevent the default action (e.g., following the link)
  
  //     console.log("dskjfwehfkjwehfkh");
  
  //     var link = $(this).attr("href");
  //     window.open(link, "_blank");
  
  //     return false;
  //   });
  // });
  
  return (
    <div className="footer-main-wrapper">
      <div className="footer-inner-wrapper">
        <div className="footer_wrapper">
          <div className="container-fluid mar-pad">
            <div class="footer main_footer_new">
              <div class="container main_container_below">
                <div class="row">
                  {/* <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="single_footer">
                      <div className="underline_indus">INDUSTRY FOCUS</div>
                      <ul className="li_list">
                        <li>
                          <a href="#">Real Estate</a>
                        </li>
                        <li>
                          <a href="#">Education</a>
                        </li>
                        <li>
                          <a href="#">Hospital</a>
                        </li>
                        <li>
                          <a href="#">Hotels & Resorts</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="single_footer single_footer_address_2">
                      <ul className="li_list">
                        <li>
                          <a href="#">Restaurants & Cafe</a>
                        </li>
                        <li>
                          <a href="#">Retail Showrooms</a>
                        </li>
                        <li>
                          <a href="#">Automobile Car</a>
                        </li>
                        <li>
                          <a href="#">IT Park</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="single_footer single_footer_address_3">
                      <ul className="li_list">
                        <li>
                          <a href="#">HOME</a>
                        </li>
                        <li>
                          <a href="#">ABOUT US</a>
                        </li>
                        <li>
                          <a href="#">OUR 360 VIRTUAL TOURS</a>
                        </li>
                        <li>
                          <a href="#">TESTIMONIALS</a>
                        </li>
                        <li>
                          <a href="#">CONTACT US</a>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                  {/* <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="row single_footer single_footer_address_4">
                      <div className="address_row row-12">
                        <div className="address_col1 col-2">
                          <img src={location} />
                        </div>
                        <div className="address_col2 col-10">
                          TIDEL Park, 305, 3rd Floor, D-North, 4, Rajiv Gandhi
                          Salai, Tharamani, Chennai, Tamil Nadu 600113
                        </div>
                      </div>
                      <div className="phonenum_row row-12">
                        <div className="phonenum_col1 col-2">
                          <img src={telephone} />
                        </div>
                        <div className="phonenum_col2 col-10">
                          <a href="tel:1800-212-6988" target="_blank" style={{textDecoration:"none",color:"white"}} >1800-212-6988</a>
                        </div>
                      </div>
                      <div className="whatsapp_row row-12">
                        <div className="whatsapp_col_1 col-2">
                          <img src={phone} />
                        </div>
                        <div className="whatsapp_col_2 col-10">
                          <a href="https://wa.me/9600062660" target="_blank" style={{textDecoration:"none",color:"white"}}>+91 96000 62660</a>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div class="col-md-12 col-sm-12 col-xs-12"> */}
                  {/* <div class=" single_footer single_footer_address_4"> */}
                  <div className=" single_footer single_footer_address_4  col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                    <div className="row address_row">
                      <div className="address_col1 col-1">
                        <img src={location} />
                      </div>
                      <div className="address_col2 col-11">
                        TIDEL Park, 305, 3rd Floor, D-North, 4, Rajiv Gandhi
                        Salai, Tharamani, Chennai, Tamil Nadu 600113
                      </div>
                    </div>
                  </div>
                  <div className="single_footer single_footer_address_4  col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div className="row phonenum_row">
                      <div className="phonenum_col1 col-2">
                        <img src={telephone} />
                      </div>
                      <div className="phonenum_col2 col-10">
                        {/* <a
                          href="tel:1800-212-6988"
                          target="_blank"
                          id="tel"
                          style={{ textDecoration: "none", color: "white" }}
                        >
                          1800-212-6988
                        </a> */}
                        <div onClick={(e)=>{e.preventDefault();window.location.href="tel:1800-212-6988"}} style={{ textDecoration: "none", color: "white",cursor:"pointer" }}>1800-212-6988</div>
                      </div>
                    </div>
                  </div>
                  <div className="single_footer single_footer_address_4  col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div className="row whatsapp_row">
                      <div className="whatsapp_col_1 col-2">
                        <img src={phone} />
                      </div>
                      <div className="whatsapp_col_2 col-10">
                        {/* <a
                          href="https://wa.me/9600062660"
                          target="_blank"
                          style={{ textDecoration: "none", color: "white" }}
                        >
                          +91 96000 62660
                        </a> */}
                        <div   onClick={(e) => {
              window.open(" https://wa.me/+919600062660");
            }} style={{ textDecoration: "none", color: "white",cursor:"pointer" }}>+91 96000 62660</div>
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                  {/* </div> */}
                </div>
              </div>
              <div class="container footer_icons ">
                {/* <div class="col-lg-12 col-sm-12 col-xs-12">
                    <p class="copyright">
                      © 2023 indiasquash.com. All rights reserved.&nbsp;|
                      <a href="/Privacypolicy" className="pri-pol">
                        &nbsp; Privacy Policy
                      </a>
                    </p>
                  </div> */}
                <div className="footer_icons_col1 ">
                  Copyright © Codoid. All Rights Reserved
                </div>
                <div className="footer_icons_col2 ">
                  <img src={instagram} />
                  <img src={facebook} />
                  <img src={linkedin} />
                  <img src={twitter} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
